/* Datum in Berliner Zeit. Fristen sind Tage (YYYY-MM-DD), ohne Uhrzeit. */

const ZONE = "Europe/Berlin";

/** Heute in Berlin als YYYY-MM-DD. */
export function heute(jetzt = new Date()): string {
  return new Intl.DateTimeFormat("sv-SE", { timeZone: ZONE, year: "numeric", month: "2-digit", day: "2-digit" }).format(jetzt);
}

function alsDatum(tag: string): Date {
  return new Date(`${tag}T12:00:00Z`);
}

/** „12.10.“ */
export function kurz(tag: string): string {
  const [, m, d] = tag.split("-");
  return `${d}.${m}.`;
}

/** „Mo 12.10.“ */
export function mitWochentag(tag: string): string {
  const wt = new Intl.DateTimeFormat("de-DE", { weekday: "short", timeZone: "UTC" }).format(alsDatum(tag)).replace(".", "");
  return `${wt} ${kurz(tag)}`;
}

/** „Montag, 12.10.2026“ */
export function lang(tag: string): string {
  return new Intl.DateTimeFormat("de-DE", { weekday: "long", day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" }).format(alsDatum(tag));
}

/** Tage von heute bis zum Tag (negativ = vorbei). */
export function tageBis(tag: string, heuteTag = heute()): number {
  return Math.round((alsDatum(tag).getTime() - alsDatum(heuteTag).getTime()) / 86_400_000);
}

/** „heute“, „morgen“, „Montag“ (innerhalb einer Woche) oder „Mo 12.10.“ */
export function relativ(tag: string, heuteTag = heute()): string {
  const n = tageBis(tag, heuteTag);
  if (n === 0) return "heute";
  if (n === 1) return "morgen";
  if (n === -1) return "gestern";
  if (n > 1 && n < 7) return new Intl.DateTimeFormat("de-DE", { weekday: "long", timeZone: "UTC" }).format(alsDatum(tag));
  return mitWochentag(tag);
}

/** 31.12. des Jahres eines Tages */
export function jahresende(tag: string): string {
  return `${tag.slice(0, 4)}-12-31`;
}

const ZEIT = new Intl.DateTimeFormat("de-DE", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", timeZone: ZONE });
export function zeitpunkt(iso: string): string {
  return ZEIT.format(new Date(iso));
}
